import { ref } from 'vue';

const useExecutionChainHook = (methodList) => {
  const executionChainController = ref({
    methodList,
    index: 0,
    launch: function () {
      this.methodList[0](this);
    },
    next: function () {
      if (this.index < (this.methodList.length - 1)) {
        this.methodList[++this.index](this);
      }
    },
  });

  return { executionChainController };
};

export default useExecutionChainHook;
